import { useEffect } from 'react'


/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Box, Grid } from '@mui/material';

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

const DonutChartExpenses = ({ keys, data, title }) => {

    // const [nDisplay, setnDisplay] = useState(1);

    useEffect(() => {

        // Create chart instance
        let hasValue = data.findIndex(f => f.nValue !== 0) !== -1;
        let chart = am4core.create("chart-donut-" + keys, am4charts.PieChart3D);
        if (hasValue) {
            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
            chart.data = data;

            chart.innerRadius = 50;
            chart.radius = am4core.percent(70);

            let series = chart.series.push(new am4charts.PieSeries3D());
            // label
            series.dataFields.value = "nValue";
            series.dataFields.category = "sName";
            series.labels.template.text = "{category}: {value.percent.formatNumber('#.00')}%";
            series.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
            series.labels.template.fontSize = 10;
            series.tooltip.label.wrap = true;
            series.tooltip.label.width = 300;

            series.ticks.template.disabled = true;
            series.labels.template.disabled = true;

            //Legend
            chart.legend = new am4charts.Legend();
            chart.legend.position = "right";
            chart.legend.scrollable = true;
            chart.legend.valueLabels.template.disabled = true;
            chart.legend.fontSize = "0.6rem";
            chart.legend.maxWidth = 300;

            chart.legend.labels.template.truncate = false;
            chart.legend.labels.template.wrap = true;

            // chart.legend.labels.template.padding(8, 8, 8, 8);
            // chart.legend.labels.template.background.cornerRadius = 20; // Set border radius

            // chart.legend.labels.template.fill = am4core.color("#fff"); // Set legend label text color
            // chart.legend.labels.template.background.fill = am4core.color("#74B266"); // Set legend label background color

            chart.legend.useDefaultMarker = true;
            let marker: any = chart.legend.markers.template.children.getIndex(0);
            marker.cornerRadius(12, 12, 12, 12);

            let markerTemplate = chart.legend.markers.template;
            markerTemplate.width = 10;
            markerTemplate.height = 10;
        } else {
            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

            let lsEmpty = [{
                "sField": "Dummy",
                "disabled": true,
                "sValue": 1000,
                "color": am4core.color("#dadada"),
                "opacity": 0.3,
                "strokeDasharray": "4,4",
                "tooltip": ""
            }];
            if (data.length !== 0) {
                data.forEach(element => {
                    lsEmpty.push({
                        "sField": element.sName,
                        "disabled": false,
                        "sValue": 0,
                        "color": am4core.color("#dadada"),
                        "opacity": 0.3,
                        "strokeDasharray": "4,4",
                        "tooltip": element.sName,
                    })
                });
            }
            chart.data = lsEmpty;
            chart.radius = am4core.percent(60);
            chart.innerRadius = am4core.percent(30)

            let series = chart.series.push(new am4charts.PieSeries3D());
            series.dataFields.value = "sValue";
            series.dataFields.category = "sField";
            series.dataFields.hiddenInLegend = "disabled";
            series.labels.template.fontSize = 10;
            series.labels.template.text = "{category}: {value.percent.formatNumber('#.00')}%";
            series.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
            series.tooltip.label.wrap = true;
            series.tooltip.label.width = 300;
            series.labels.template.maxWidth = 180;
            series.labels.template.wrap = true;


            /* Set tup slice appearance */
            var slice = series.slices.template;
            slice.propertyFields.fill = "color";
            slice.propertyFields.fillOpacity = "opacity";
            slice.propertyFields.stroke = "color";
            slice.propertyFields.strokeDasharray = "strokeDasharray";
            slice.propertyFields.tooltipText = "tooltip";

            series.labels.template.propertyFields.disabled = "disabled";
            series.ticks.template.propertyFields.disabled = "disabled";

            /* This creates initial animation */
            series.hiddenState.properties.opacity = 1;
            series.hiddenState.properties.endAngle = -90;
            series.hiddenState.properties.startAngle = -90;

            //Legend
            chart.legend = new am4charts.Legend();
            chart.legend.position = "right";
            chart.legend.scrollable = true;
            chart.legend.valueLabels.template.disabled = true;
            chart.legend.fontSize = "0.6rem";
            chart.legend.maxWidth = 300;

            chart.legend.labels.template.truncate = false;
            chart.legend.labels.template.wrap = true;

            // chart.legend.labels.template.padding(8, 8, 8, 8);
            // chart.legend.labels.template.background.cornerRadius = 20; // Set border radius

            // chart.legend.labels.template.fill = am4core.color("#fff"); // Set legend label text color
            // chart.legend.labels.template.background.fill = am4core.color("#74B266"); // Set legend label background color

            chart.legend.useDefaultMarker = true;
            let marker: any = chart.legend.markers.template.children.getIndex(0);
            marker.cornerRadius(12, 12, 12, 12);

            let markerTemplate = chart.legend.markers.template;
            markerTemplate.width = 10;
            markerTemplate.height = 10;
        }

        // Cleanup on component unmount
        return () => {
            chart.dispose();
        };
    }, [data, keys])

    return (
        <Grid item xs={12} pt={3} sx={{ position: "relative" }}>
            <Box className="label-donut">{title}</Box>
            <div id={"chart-donut-" + keys} style={{ width: "100%", height: "350px", background: "rgb(223 248 255)", borderRadius: "2rem" }}></div>
        </Grid>
    )
}

export default DonutChartExpenses;